var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"hidden-md-and-up text-xs-right",attrs:{"flat":""},on:{"click":_vm.btnClick}},[_vm._v(_vm._s(_vm._f("translation")('Filters')))])}
var staticRenderFns = []

export { render, staticRenderFns }